<template>
  <vue-draggable-resizable
    class="draggableItem"
    drag-cancel=".dragCancel"
    >
    <div class="draggableItem__header">
      <span class="draggableItem__title">Computed property: {{ propName }}</span>
      <a
        href="#"
        class="draggableItem__close dragCancel"
        @click.prevent="close"
        v-b-tooltip.hover
        title="close"
        >
        <icon name="remove" />
      </a>
    </div>
    <div class="draggableItem__body">
      <codemirror
        :value="code"
        :options="cmOptions"
        @input="onCmCodeChange"
        @keydown.ctrl.83.native.prevent="save"
        class="dragCancel"
        :ref="'draggable_' + propName"
        />
      <div class="submitComputed">
        <b-button
          variant="primary"
          size="sm"
          type="submit"
          :disabled="!changed"
          class="dragCancel"
          @click="save"
          >
          Save
        </b-button>
      </div>
    </div>
  </vue-draggable-resizable>
</template>

<script>
// services
import db from '@/services/db'

let $ = window.$

export default {
  props: ['propName', 'propVal'],
  data () {
    return {
      code: this.propVal,
      cmOptions: {
        tabSize: 2,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter'
        ],
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
        hintOptions: {
          completeSingle: false
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        extraKeys: {
          'Ctrl': 'autocomplete'
        },
        mode: 'text/javascript'
      },
      width: 0,
      height: 0,
      x: 0,
      y: 0
    }
  },
  computed: {
    changed () {
      if (this.code != this.propVal) return true // eslint-disable-line
      return false
    }
  },
  methods: {
    close () {
      let vm = this
      this.$store.commit('editComputed', {
        key: vm.propName,
        insert: false
      })
    },
    onCmCodeChange (code) {
      this.code = code
    },
    save () {
      db.computed.update(this.propName, this.code)
    }
  },
  mounted () {
    $(this.$refs['draggable_' + this.propName].$el)
      .find('textarea')
      .focus()
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.submitComputed {
  margin-top: 15px;
}
.vue-codemirror {
  height: calc(100% - 46px);
  border: 1px solid $borderColor1;
}
.CodeMirror {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ComputedPropEdit/Draggable.vue